var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5294 7.59573L1.30242 0.0402936C1.22397 0.0128242 1.13929 0.00845729 1.05844 0.0277116C0.977586 0.0469658 0.903961 0.0890325 0.846318 0.14891C0.788675 0.208787 0.749439 0.283956 0.733271 0.365483C0.717103 0.44701 0.724686 0.531464 0.755117 0.608807L2.33126 6.27768C2.37685 6.44117 2.4717 6.58664 2.6029 6.69431C2.7341 6.80198 2.89529 6.86661 3.06453 6.87943L16.3638 7.86372C16.4515 7.87079 16.641 7.90756 16.6389 7.99737C16.6367 8.08717 16.4564 8.12889 16.3687 8.13596L3.22928 8.91661C3.05131 8.92679 2.88146 8.99448 2.74527 9.1095C2.60908 9.22453 2.51391 9.38066 2.47409 9.55441L1.04432 15.719C1.01863 15.7966 1.01528 15.8799 1.03465 15.9593C1.05403 16.0387 1.09534 16.1111 1.15389 16.1682C1.21244 16.2253 1.28586 16.2647 1.36576 16.2821C1.44566 16.2994 1.52883 16.2939 1.60577 16.2663L20.5357 8.41244C20.6195 8.38154 20.6918 8.32552 20.7426 8.25204C20.7934 8.17855 20.8203 8.09118 20.8196 8.00185C20.8189 7.91251 20.7906 7.82557 20.7387 7.75289C20.6868 7.6802 20.6137 7.62532 20.5294 7.59573Z",
    fill: "#722ED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.6139194615ae0cd622c2cf366313514f.svg";
export { ForwardRef as ReactComponent };